import { render, staticRenderFns } from "./createEditGroup.vue?vue&type=template&id=2eafb616&scoped=true&"
import script from "./createEditGroup.vue?vue&type=script&lang=js&"
export * from "./createEditGroup.vue?vue&type=script&lang=js&"
import style0 from "./createEditGroup.vue?vue&type=style&index=0&id=2eafb616&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eafb616",
  null
  
)

export default component.exports